import React from "react";
import Home from "./pages/Home";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import PublicRoute from "./components/auth/PublicRoute";
import PrivateRoute from "./components/auth/PrivateRoute";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Products from "./pages/Products";
import Checkout from "./pages/Checkout";
import ThankYou from "./pages/ThankYou";
import Footer from "./pages/Footer";

const App = () => {
  return (
    <Router>
      <Switch>
        <PublicRoute path="/" exact>
          <Home />
        </PublicRoute>
        <PublicRoute path="/login" exact>
          <Login />
        </PublicRoute>
        <PublicRoute path="/register" exact>
          <Register />
        </PublicRoute>
        <PrivateRoute path="/checkout" exact>
          <Checkout />
        </PrivateRoute>
        <Route path="/products" exact>
          <Products />
        </Route>
        <Route path="/explore" exact>
          <Redirect to="/products" />
        </Route>
        <PrivateRoute path="/thank-you" exact>
          <ThankYou />
        </PrivateRoute>
      </Switch>
      <Footer />
    </Router>
  );
};

export default App;
